var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6748 3.45824C11.7542 2.85237 11.0903 1.88254 10.8829 0.752581C10.8383 0.508501 10.8135 0.257063 10.8135 0H7.876L7.87129 11.8872C7.822 13.2184 6.73684 14.2869 5.40696 14.2869C4.99338 14.2869 4.60423 14.1826 4.26136 14.0004C3.47535 13.5828 2.93748 12.751 2.93748 11.7938C2.93748 10.4189 4.04536 9.30016 5.40653 9.30016C5.66067 9.30016 5.90454 9.34257 6.13511 9.41527V6.3872C5.89639 6.35431 5.65382 6.33397 5.40653 6.33397C2.42533 6.33397 0 8.783 0 11.7938C0 13.6408 0.913731 15.2754 2.30833 16.2638C3.18649 16.8866 4.25493 17.2531 5.40696 17.2531C8.38815 17.2531 10.8135 14.8041 10.8135 11.7938V5.76575C11.9655 6.60056 13.3772 7.09261 14.9004 7.09261V4.12643C14.0801 4.12643 13.316 3.88019 12.6748 3.45824Z",
    fill: "#12233D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.bf181f1821265257ae16022374dd2a63.svg";
export { ForwardRef as ReactComponent };